<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-program-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 v-if="isMain">STAFF MEMBERS</h4>
      <h4 v-else-if="isEdit">EDIT STAFF</h4>
      <h4 v-else-if="isPage">ADD NEW STAFF MEMBER</h4>
       <h4 v-else>ADD NEW STAFF MEMBER</h4>

      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :key="$vs.rtl"
    >
    <div id="program-content">

    </div>
        <image-library-sidebar
      @setImg="setImg"
      :isSidebarActive="ImageViewSidebar"
      @closeSidebar="toggleImageSidebar"
    />
     <add-staff-page
      :pageData="newMember"
      :isSidebarActive="isPageCreate"
      @setStaffTemplate="setStaffTemplate"
    />
     <div class="p-3" v-if="staffData">
      <span v-if="isMain">
          <div class="w-full cursor-pointer p-2 font-bold text-primary flex justify-between">
           <small class="text-center">ALL STAFF MEMBERS</small>
           <span class="flex-inline">
             <vs-dropdown vs-trigger-click class="cursor-pointer">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <vs-dropdown-menu>
                  <vs-dropdown-item  @click="isNew=true;isMain=false;isEdit=false,isPage=false">
                    <span class="flex items-center mt-2">
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <small  class="font-semibold">Staff Member</small>
                    </span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
           </span>
         </div>
              <ul class="vs-list mb-base">
              <li
                v-for="(service,index) in staffData.members" :key="index"
                class="w-full cursor-pointer ml-2 p-2"
                 @mouseover="mouseOver(index,'')"
                @mouseleave="mouseLeave(index,'')"
                :ref="'li-with-'+index+'-'"
              >
                <span class="flex items-center">
                  <span>{{ service.name }}</span>
                  <span class="ml-auto mr-12 hidden" :ref="'div-with-'+index+'-'">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" />
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="editPro(index)">
                          <span class="flex items-center mt-2">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small  class="font-semibold">Edit</small>
                          </span>
                          </vs-dropdown-item>
                          <vs-dropdown-item @click="deletePro(index)">
                          <span class="flex items-center mt-2 text-danger" >
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small class="font-semibold">Delete</small>
                          </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gotoPage(index,service.name)">
                          <span class="flex items-center mt-2 " >
                            <feather-icon
                              icon="PlusIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small class="font-semibold">Goto Page</small>
                          </span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </span>
                </span>
              </li>
            </ul>   
      </span> 
      <span v-if="isNew">
        <vs-input  label-placeholder="Name"  v-model="newMember.name" class="w-full mb-base"></vs-input>
        <vs-input  label-placeholder="Link"   v-model="newMember.link" class="w-full mb-base hidden"></vs-input>
        <vs-textarea label="About" v-model="newMember.details" class="w-full"></vs-textarea>
      <vs-row class="mb-base">
        <vs-col v-if="newMember.image" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <img :src="newMember.image" alt="" width="150px" height="150px">
        </vs-col>
        <vs-col  vs-w="6">
          <vs-button color="primary" @click.native="toggleImageSidebar(true)"
                  >Upload Image</vs-button>
        </vs-col>
      </vs-row>
      </span>
       <span v-if="isEdit">
        <vs-input  label-placeholder="Name" v-model="editMember.name" class="w-full mb-base"></vs-input>
        <!-- <vs-input  label-placeholder="Link" v-model="editProgram.link" class="w-full mb-base"></vs-input> -->
        <vs-textarea label="About" v-model="editMember.details" class="w-full"></vs-textarea>
         <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <img v-if="editMember.image" :src="editMember.image" alt="" width="150px" height="150px">
        </vs-col>
        <vs-col  vs-w="6">
          <vs-button color="primary" @click.native="toggleImageSidebar(true)"
                  >Browse</vs-button>
        </vs-col>
      </vs-row>
      </span>
     </div>
    </component>
     <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isMain">
      <vs-button class="mr-6" @click.native="createStaff" :disabled="!isProgramValid">Create</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isEdit">
         <vs-button class="mr-6" @click.native="editSaveStaff">Save</vs-button>      
         <vs-button type="border" color="danger" @click="isMain=true;isNew=false;isEdit=false;isPage=false">Cancel</vs-button>
    </div>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isNew">
      <vs-button class="mr-6" @click.native="createNewStaff">Create</vs-button>         
      <vs-button type="border" color="danger" @click="isMain=true;isNew=false;isEdit=false;isPage=false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ImageLibrarySidebar from "./ImageLibrarySidebar.vue";
import addStaffPage from "./addStaffPage.vue";
import { CREATE_NEW_PROGRAM_TEMPLATE } from "@/graphql";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: String,
    },
    currentPage:{
       type: Object,
    }
  },
  components: {
    VuePerfectScrollbar,
     "image-library-sidebar": ImageLibrarySidebar,
      "add-staff-page": addStaffPage,
  },
  data() {
    return {
      StaffData:{
          members:[
            {
              link:"/curriculum/infants.phtml",
              image:'https://kvadmin01.s3.us-east-2.amazonaws.com/files/TeamImage/262175584841837.jpeg',
              name:'Alina Rohdes',
              details:`Advantage's Infant Program provides personal care and attention for your child as they begin developing trust for the world.`,
            },
            {
              link:"/curriculum/toddlers.phtml",
              image:'https://kvadmin01.s3.us-east-2.amazonaws.com/files/TeamImage/6093613677781988.png',
              name:'Camron Carlos',
              details:`Our Toddlers Program is designed with the best age-appropriate activities to help children feel secure in their developing independence.`,
            },
            {
              link:"/curriculum/preschool.phtml",
              image:'https://kvadmin01.s3.us-east-2.amazonaws.com/files/TeamImage/8252154852346469.jpeg',
              name:'Hana Mcgregor',
              details:`The Preschool program is an early childhood program that helps set your child up for a successful
                     and confident school career.`,
            },
              {
              link:"/curriculum/school.phtml",
              image:'https://kvadmin01.s3.us-east-2.amazonaws.com/files/TeamImage/7855249413185148.jpeg',
              name:'Melania Adward',
              details:`Our school age program provides new challenges, close friendships, and increasing responsibilities for our oldest learners.`,
            },
            {
              link:"/curriculum/summer.phtml",
              image:'https://kvadmin01.s3.us-east-2.amazonaws.com/files/TeamImage/9285980153152327.jpeg',
              name:'Richerd clark',
              details:`Drama classes, fun weekly field trips, and craft classes are just a few of the activities your child will enjoy at Advantage over the summer.`,
            }
          ]
},
      ImageViewSidebar: false,
      proDom:null,
      finalProgram:null,
      isMain:true,
      isNew:false,
      isEdit:false,
      isPage:false,
      editMember:null,
      current:null,
      isPageCreate:false,
      newMember: {
              link:"",
              image:'',
              name:'',
              details:'',
            },
      activeLoading : false    ,
      staffData:null,
    }
  },
  watch: {
    isNew(val){
      if(!val){
        this.newMember = {
              link:"",
              image:'',
              name:'',
              details:'',
            }
      }
    },
    isEdit(val){
      if(!val){
         this.current = null
      }
    },
    staffData: {
      handler(val, oldVal) {
         this.StaffData = val
      },
      deep: true,
    },
    isSidebarActive(val) {
      if(val){
        this.isMain=true
        this.isNew=false
        this.isEdit=false
         this.isPage=false
         this.isPageCreate=false
          this.initValues();
          if(localStorage.getItem('staff_member_list')){
           this.staffData=JSON.parse(localStorage.getItem('staff_member_list'))
        }
        else{
            this.staffData=this.StaffData
        }
      }

    },

  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isProgramValid() {
      return (
        !this.errors.any() 
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
      gotoPage(index,name){
      var page_name = name
      page_name = page_name.replaceAll(' ','')
      this.newMember.name=this.staffData.members[index].name
      this.current=index
      var site={
        'sitePage':page_name+'.html',
        'siteName':this.currentPage.siteName
      }
      console.log(site)
      this.$emit("setPage", site);
    },
    setStaffTemplate(val){
      if(this.newMember.name){
      var name = this.newMember.name
      name = name.replaceAll(' ','')
      this.loader();
      this.$apollo
         .mutate({
          mutation: CREATE_NEW_PROGRAM_TEMPLATE,
          variables: {
            page:name+'.html',
            site:this.currentPage.siteName,
            html:val
          },
        })
        .then((response) => {
          if(response.data.createNewProgramTemplate.status==='Success'){
            this.newMember.link='/'+this.newMember.name+'.html'
            this.staffData.members.push(this.newMember);
            this.activeLoading = false;
            this.$vs.loading.close();
            this.$nextTick(() => {
             this.createStaff()
            })
            
          }
          else{
           alert("Name Already exist")
           this.activeLoading = false;
          this.$vs.loading.close();
          }
          // this.renderPage(response.data.getPageContent.template);
        })
        .catch((error) => {
          console.log(error);
          this.activeLoading = false;
          this.$vs.loading.close();
        });
         this.isPageCreate=false
     }
    },
    createProgramPage(){
       this.isPageCreate=true
    },

    editSaveStaff(){
      var current = this.current
      this.staffData.members[current] = this.editMember
      this.createStaff()
    },
    editPro(index){
      this.current = index
      this.editMember=this.staffData.members[index]
      this.isEdit=true
      this.isMain=false
      this.isNew=false
      this.isPage=false
    },
    deletePro(i){
      this.staffData.members.splice(i, 1);

    },
    setImg(val){
     if(this.isNew){
       this.newMember.image=val
     } 
     if(this.isEdit){
       this.editMember.image=val
     }
    },
    toggleImageSidebar(val = false) {
      this.ImageViewSidebar = val;
    }, 
   createNewStaff(){
     this.isPageCreate=true
  },
  createStaff(){
      // this.$emit('creatProgrm',this.$refs.program_data.innerHTML)
      localStorage.setItem('staff_member_list',JSON.stringify(this.staffData))
      this.isEdit=false
      this.isMain=true
      this.isNew=false
      this.isPage=false
  },
     loader() {
      this.activeLoading = true;
      this.$vs.loading({
        type: "sound",
      });
    },
initValues (){

},   
 mouseOver: function (parent,node) {
           var referenceIcon=`div-with-${parent}-${node}`
           var referenceLi=`li-with-${parent}-${node}`
           const icon_element = this.$refs[referenceIcon]
           const li_element = this.$refs[referenceLi]
           icon_element[0].classList.remove('hidden');
           li_element[0].classList.add('menuHover');
          //  li_element[0].classList.add('text-white');
    },
    mouseLeave: function (parent,node) {
           var referenceIcon=`div-with-${parent}-${node}`
           var referenceLi=`li-with-${parent}-${node}`
           const icon_element = this.$refs[referenceIcon]
           const li_element = this.$refs[referenceLi]
            icon_element[0].classList.add('hidden');
            li_element[0].classList.remove('menuHover');    
            // li_element[0].classList.remove('text-white');
    },
  },
  created(){
    
  }
}
</script>

<style lang="scss" scoped>
.add-program-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 350px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
button.btn-async {
  background: rgba(var(--vs-warning), 0.15);
}

button.btn-delete {
  background: rgba(var(--vs-danger), 0.15);
}
.con-vs-dropdown--menu {
  z-index: 999999;
}
.menuHover{
  border-left: #5C52C0 4px solid;
  background: #F8F8F8;
}

</style>
